import { render } from "./SoftwareAbout.vue?vue&type=template&id=5784b79b&scoped=true"
import script from "./SoftwareAbout.vue?vue&type=script&lang=js"
export * from "./SoftwareAbout.vue?vue&type=script&lang=js"

import "./SoftwareAbout.vue?vue&type=style&index=0&id=5784b79b&scoped=true&lang=css"

import exportComponent from "/Users/guohongcheng/Documents/jeff/jeff_spn_mini/user_interface/web/vue/tianping/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5784b79b"]])

export default __exports__